export default __webpack_public_path__ + "static/media/browser.890ba6ea.png";